import React from 'react';
import './style.scss';

export default function Footer({ ...rest }) {
  return <footer className={'footer'} {...rest} />;
}
